import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { Provider } from 'react-redux';
import store from './redux-tool/store';
import './js/variables.global.js';
import './js/toolButtonState.js';
import './js/geometries/DecalGeometry.js';
import './js/controls/OrbitControls.js';
import './js/loaders/OBJLoader.js';
import './js/copyText.js';
import './js/sharing.js';
import './js/colorHandling.js';
import './js/textHandling.js';
import './js/tab.js';
import './js/fontSelector.js';
import './js/patternHandling.js';
import './js/styleHandling.js';
import './js/webGL.js';
import './js/undoRedoLogo.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
